import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill, RiCloseFill} from "react-icons/ri";
import axios from "axios";
import {acceptFriendRequestRoute, checkFriendshipStatus, sendFriendRequestRoute} from "../../utils/apiRoutes";
import {setAlert} from "../../Redux/actions/alertAction";
import {selectContact} from "../../Redux/actions/contactAction";
import multiavatar from "@multiavatar/multiavatar/esm";

const ChatHeader = ({selectContact, selectedContact, setAlert}) => {
    const [forceRender, setForceRender] = useState(false);
    const [friendshipStatus, setFriendshipStatus] = useState(null);

    async function getFriendshipStatus() {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const body = JSON.stringify({friendId: selectedContact.id});

        try {
            const res = await axios.post(checkFriendshipStatus, body, config);
            setFriendshipStatus(res.data);
        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    }

    useEffect(() => {
        getFriendshipStatus();
    }, []);

    const sendFriendRequest = async () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({friendId: selectedContact.id});

        try {
            const res = await axios.post(sendFriendRequestRoute, body, config);

            setAlert(res.data.msg, 'success');
            setForceRender(!forceRender);
            getFriendshipStatus();
        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    }

    const acceptFriendRequest = async () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({friendId: selectedContact.id});

        try {
            const res = await axios.post(acceptFriendRequestRoute, body, config);

            setAlert(res.data.msg, 'success');
            setForceRender(!forceRender);
            getFriendshipStatus();

        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    }

    return (
        <Container>
            <div className='account-container'>
                {
                    selectedContact.avatarImage ?
                        <div className='avatar'
                             dangerouslySetInnerHTML={{__html: multiavatar(selectedContact.avatarImage)}}>
                        </div>
                        :
                        <RiAccountCircleFill className='avatar-icon'/>
                }                <h4>{selectedContact.name}</h4>
            </div>

            <div className='flex-container'>

                {!!friendshipStatus && !friendshipStatus.isFriend ?
                    <>
                        {!friendshipStatus.sentRequest ? null :
                            <div>
                                <p>Request sent!</p>
                            </div>
                        }

                        {friendshipStatus.sentRequest || friendshipStatus.receivedRequest ? null :
                            <div>
                                <input type='button' className='sign-button' value='Add friend'
                                       onClick={() => sendFriendRequest()}/>
                            </div>
                        }

                        {!friendshipStatus.receivedRequest ? null :
                            <div>
                                <input type='button' className='sign-button' value='Accept friend'
                                       onClick={() => acceptFriendRequest()}/>
                            </div>
                        }
                    </>
                    : null
                }
                <RiCloseFill className='menu-icon' onClick={() => selectContact(null)}/>
            </div>
        </Container>
    );
}

ChatHeader.propTypes = {
    selectedContact: PropTypes.object,
    selectContact: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    selectedContact: state.contact.selectedContact,
    setAlert: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {selectContact, setAlert})(ChatHeader);

const Container = styled.div`
  display: flex;
  padding: 40px 8px;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-bottom: #F0EFF5 1px solid;
  z-index: 1;

  .account-container {
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
  }

  .menu-icon {
    font-size: 20px;
    padding: 15px;
    border-radius: 0.5rem;
    cursor: pointer;
    color: #878A92;
  }

  .avatar {
    width: 2.3rem;
    padding-right: 15px;
  }

  .avatar-icon {
    font-size: 40px;
    padding-right: 15px;
  }

  .flex-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .sign-button {
    cursor: pointer;
    color: #fff;
    background-color: #7269ef;
    line-height: 1.5;
    padding: 0.65rem 1rem;
    border-radius: 0.25rem;
    border: none;
    transition: 0.25s;
    font-size: 0.9rem;

    :hover {
      background-color: #6159cb;
      border-color: #5b54bf;
    }
  }
`;